// extracted by mini-css-extract-plugin
export default {"Title":"h5z5B7Hh"};